import { connect, ConnectedProps } from 'react-redux';
import { progressSelectorFactory } from '../../../../common/store/selectors';
import { RootState } from '../../../../reducers';
import { selectClientId, selectEntityDetails } from '../common/store/selectors';
import { CashAccounts } from './components/cashAccounts';
import {
  selectAccountsForPortfolio,
  selectCanShowAudValues,
  selectCashStatementResults,
  selectLastDataRefresh,
  selectParameters,
  selectShowAudValues,
} from './store/selectors';
import { cashAccountsSlice } from './store/slice';
import { CashAccountsActionTypes, downloadCashStatements, fetchCashStatements } from './store/thunks';

const mapStateToProps = (state: RootState) => ({
  clientId: selectClientId(state),
  entityDetails: selectEntityDetails(state),
  cashStatements: selectCashStatementResults(state),
  lastDataRefresh: selectLastDataRefresh(state),
  portfolioAccounts: selectAccountsForPortfolio(state),
  parameters: selectParameters(state),
  showAudValues: selectShowAudValues(state),
  canShowAudValues: selectCanShowAudValues(state),
  progressCashStatements: progressSelectorFactory([CashAccountsActionTypes.FetchCashStatements])(state),
});

const mapDispatchToProps = {
  ...cashAccountsSlice.actions,
  fetchCashStatements,
  downloadCashStatements,
};

const connector = connect(mapStateToProps, mapDispatchToProps);
export type Props = ConnectedProps<typeof connector>;
export const CashAccountsStateContainer = connect(mapStateToProps, mapDispatchToProps)(CashAccounts);
